import { ReactNode } from 'react'
import { Label } from '../Label/Label'
import styles from './styles/Radio.module.css'
import { FormikErrors, FormikTouched } from 'formik'

export type IRadioOption<T = any> = {
  id: number | string
  descricao: ReactNode
  value: T
  /** Desabilita só esta opção (ex.: a opção que já é o valor vigente). */
  disabled?: boolean
}

type IRadio<T = any> = {
  onChange?: (value: T) => void
  onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void
  options: IRadioOption<T>[]
  name?: string
  className?: string
  id: string
  touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined
  error?: string | FormikErrors<any> | FormikErrors<any>[] | undefined | string[]
  value?: T
  disabled?: boolean
  isColumn?: boolean
  /** `sm` para listas e painéis compactos; o padrão é o tamanho do tema. */
  size?: 'sm' | 'md'
}

export const Radio = <T,>({
  onChange,
  onBlur,
  className = '',
  options,
  id,
  touched = false,
  error = '',
  value,
  disabled = false,
  isColumn,
  size = 'md',
}: IRadio<T>) => {
  return (
    <div className={`d-flex ${isColumn ? 'flex-column' : 'flex-wrap'}`} style={{ gap: '1rem' }}>
      {options.map((option) => (
        <div key={option.id} className='form-check d-flex align-items-center'>
          <input
            type='radio'
            id={`${id}_${option.value}`}
            name={id}
            value={String(option.value)}
            onChange={() => onChange?.(option.value)}
            onBlur={onBlur}
            checked={option.value === value}
            className={`form-check-input ${size === 'sm' ? styles.sm : ''} ${
              touched && error ? 'is-invalid' : ''
            } ${className}`}
            disabled={disabled || option.disabled}
          />
          <Label
            htmlFor={`${id}_${option.value}`}
            disabled={disabled || option.disabled}
            className={`ms-1 ${touched && error ? 'is-invalid' : ''}`}
          >
            {option.descricao}
          </Label>
        </div>
      ))}
    </div>
  )
}
